import { render, staticRenderFns } from "./ComponentCompositionDialog.vue?vue&type=template&id=c63f01e2&scoped=true&"
import script from "./ComponentCompositionDialog.vue?vue&type=script&lang=js&"
export * from "./ComponentCompositionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f01e2",
  null
  
)

export default component.exports